export default __webpack_public_path__ + "static/media/snow.69170679.png";